import {
  Box,
  Skeleton,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const PackageSkeleton = () => {
  return (
    <>
      <Box p={2} display="flex" flexDirection="column" gap={3}>
        {/* Top Filters */}
        <Box display="flex" gap={2} alignItems="center">
          <Skeleton
            variant="rectangular"
            width={250}
            height={40}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={120}
            height={40}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={120}
            height={40}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={120}
            height={40}
            sx={{ borderRadius: 1 }}
          />
        </Box>

        {/* Total Number */}
        <Typography variant="h6">
          <Skeleton width={300} />
        </Typography>

        {/* Charts Section */}
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Paper
              key={i}
              sx={{
                p: 2,
                height: 280,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {/* Title */}
              <Typography variant="subtitle1">
                <Skeleton width={120} height={24} />
              </Typography>

              {/* Circle + lines */}
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 3,
                }}
              >
                {/* Circle with rounded animation */}
                <Skeleton
                  variant="circular"
                  width={160}
                  height={160}
                  sx={{
                    borderRadius: "50%",
                    animation: `roundedGrow 1s ease-out forwards`,
                    "@keyframes roundedGrow": {
                      "0%": {
                        transform: "scale(0.5)",
                        opacity: 0.2,
                        borderRadius: "30%",
                      },
                      "50%": {
                        transform: "scale(1.1)",
                        opacity: 0.6,
                        borderRadius: "40%",
                      },
                      "100%": {
                        transform: "scale(1)",
                        opacity: 1,
                        borderRadius: "50%",
                      },
                    },
                  }}
                />

                {/* Text lines */}
                <Box display="flex" flexDirection="column" gap={1}>
                  {Array.from({ length: 5 }).map((__, j) => (
                    <Skeleton key={j} width={120 + j * 20} height={20} />
                  ))}
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>

        {/* Table Section */}
        <Paper sx={{ p: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  "Package",
                  "First Run",
                  "Last Run",
                  "Process Count",
                  "Status",
                  "Brand",
                  "Interface",
                  "Run Method",
                  "Run By",
                ].map((col) => (
                  <TableCell key={col}>
                    <Skeleton width={80} />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 10 }).map((_, i) => (
                <TableRow key={i}>
                  {Array.from({ length: 9 }).map((__, j) => (
                    <TableCell key={j}>
                      <Skeleton width="90%" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Pagination */}
          <Box
            mt={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton width={120} height={30} />
            <Skeleton width={200} height={30} />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default PackageSkeleton;
